import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "pd-progress",
  "aria-hidden": "true"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "pd-main" }
const _hoisted_5 = { class: "pd-hero" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "/", -1 /* HOISTED */)
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "pd-title" }
const _hoisted_11 = {
  key: 0,
  class: "pd-lede"
}
const _hoisted_12 = { class: "pd-meta" }
const _hoisted_13 = {
  key: 0,
  class: "pd-chip pd-chip--accent"
}
const _hoisted_14 = {
  key: 1,
  class: "pd-chip"
}
const _hoisted_15 = { class: "pd-tools" }
const _hoisted_16 = {
  key: 0,
  class: "pd-lang"
}
const _hoisted_17 = { class: "pd-visually-hidden" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  ref: "content",
  class: "pd-content"
}
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "pd-aside" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pd-layout", { 'is-nav-open': $setup.navOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        style: _normalizeStyle({ transform: `scaleX(${$setup.progress})` })
      }, null, 4 /* STYLE */)
    ]),
    _createElementVNode("aside", {
      class: "pd-side",
      "aria-label": $setup.t('User manual')
    }, [
      _createVNode($setup["SideNav"], {
        tree: $setup.docs.tree,
        current: $setup.path,
        section: $setup.docs.section,
        home: $setup.docs.home,
        onNavigate: _cache[0] || (_cache[0] = $event => ($setup.navOpen = false))
      }, null, 8 /* PROPS */, ["tree", "current", "section", "home"])
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("button", {
      class: "pd-scrim",
      type: "button",
      "aria-label": $setup.t('Close the menu'),
      onClick: _cache[1] || (_cache[1] = $event => ($setup.navOpen = false))
    }, null, 8 /* PROPS */, _hoisted_3),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("header", _hoisted_5, [
        _createElementVNode("nav", {
          class: "pd-crumbs",
          "aria-label": $setup.t('Breadcrumb')
        }, [
          _createElementVNode("a", {
            href: $setup.docs.home
          }, _toDisplayString($setup.t("User manual")), 9 /* TEXT, PROPS */, _hoisted_7),
          ($setup.section && $setup.section.route !== $setup.path)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_8,
                _createElementVNode("a", {
                  href: $setup.section.route
                }, _toDisplayString($setup.section.title), 9 /* TEXT, PROPS */, _hoisted_9)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_6),
        _createElementVNode("h1", _hoisted_10, _toDisplayString($setup.title), 1 /* TEXT */),
        ($setup.lede)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString($setup.lede), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_12, [
          ($setup.section)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.section.title), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.minutes)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($setup.minutes) + " " + _toDisplayString($setup.t("min read")), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "pd-chip pd-chip--button",
            type: "button",
            onClick: $setup.copyLink
          }, _toDisplayString($setup.copied ? $setup.t("Link copied") : $setup.t("Copy link")), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "pd-menu",
            type: "button",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.navOpen = true))
          }, _toDisplayString($setup.t("Sections")), 1 /* TEXT */),
          _createElementVNode("button", {
            class: "pd-search-trigger",
            type: "button",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.searchOpen = true))
          }, [
            _createElementVNode("span", null, _toDisplayString($setup.t("Search the manual")), 1 /* TEXT */),
            _createElementVNode("kbd", null, _toDisplayString($setup.shortcut), 1 /* TEXT */)
          ]),
          ($setup.docs.languages && $setup.docs.languages.length > 1)
            ? (_openBlock(), _createElementBlock("label", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.t("Language")), 1 /* TEXT */),
                _createElementVNode("select", {
                  value: $setup.docs.lang,
                  onChange: _cache[4] || (_cache[4] = $event => ($setup.changeLanguage($event.target.value)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.docs.languages, (language) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: language.code,
                      value: language.code
                    }, _toDisplayString(language.name), 9 /* TEXT, PROPS */, _hoisted_19))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_18)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, null, 512 /* NEED_PATCH */),
      ($setup.docs.prev || $setup.docs.next)
        ? (_openBlock(), _createElementBlock("nav", {
            key: 0,
            class: "pd-pager",
            "aria-label": $setup.t('More pages')
          }, [
            ($setup.docs.prev)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "pd-card",
                  href: $setup.docs.prev.route
                }, [
                  _createElementVNode("small", null, _toDisplayString($setup.t("Previous")), 1 /* TEXT */),
                  _createElementVNode("strong", null, _toDisplayString($setup.docs.prev.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_22))
              : (_openBlock(), _createElementBlock("span", _hoisted_23)),
            ($setup.docs.next)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "pd-card pd-card--next",
                  href: $setup.docs.next.route
                }, [
                  _createElementVNode("small", null, _toDisplayString($setup.t("Next")), 1 /* TEXT */),
                  _createElementVNode("strong", null, _toDisplayString($setup.docs.next.title), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_24))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_21))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("aside", _hoisted_25, [
      _createVNode($setup["Toc"], {
        items: $setup.headings,
        active: $setup.activeHeading,
        progress: $setup.progress,
        label: $setup.t('On this page'),
        "top-label": $setup.t('Back to top')
      }, null, 8 /* PROPS */, ["items", "active", "progress", "label", "top-label"])
    ]),
    ($setup.searchOpen)
      ? (_openBlock(), _createBlock($setup["SearchPalette"], {
          key: 0,
          pages: $setup.pages,
          labels: $setup.searchLabels,
          onClose: _cache[5] || (_cache[5] = $event => ($setup.searchOpen = false))
        }, null, 8 /* PROPS */, ["pages"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}